<template>
  <div class="row">
    <div class="col-md-12">
      <form method="get" action="/" class="form-horizontal">
        <fieldset>
          <div class="form-group">
            <label class="col-sm-8 control-label">Customer</label>
            <div class="col-sm-4">
              <el-select
                v-model="formData.customerID"
                ref="customerID"
                placeholder="Select Customer"
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="`${item.thName} / ${item.enName}`"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-8 control-label">Shipment Date</label>
            <div class="col-sm-4">
              <el-date-picker
                :disabled="formData.customerID === ''"
                class="custom-datepicket"
                v-model="formData.shipmentDate"
                type="date"
                format="dd/MM/yyyy"
                value-format="yyyy-MM-dd"
                placeholder="Pick a day"
                @change="onChangeShipmentDate"
                :picker-options="pickerOptions1"
                >
              </el-date-picker>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-8 control-label">MAWB Number</label>
            <div class="col-sm-4">
              <!-- <el-select
                v-model="formData.mawbID"
                ref="customerID"
                placeholder="Select Customer"
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="`${item.thName} / ${item.enName}`"
                  :value="item.id"
                ></el-option>
              </el-select> -->
              <el-select
                :disabled="formData.customerID === ''"
                style="width:200px margin-right: 10px"
                placeholder="Select MAWB"
                v-model="formData.mawbID" clearable @change="onChangeMawb">
                <el-option
                  v-for="option in mawbList"
                  :value="option.mawb"
                  :label="`${option.customer ? option.customer+' | ' : ''}${option.vessel && option.vessel+ ' /' } ${option.mawb}`"
                  :key="option.mawb"
                >
                  <!-- :label="`${option.vessel && option.vessel+ ' /' } ${option.mawb}`" -->

                <span style="float: left">{{option.vessel && option.vessel+ ' /' }} {{option.mawb}}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">
                  <i class="nc-icon nc-check-2 text-success" v-if="option.isInfoLink"></i>
                  <i class="nc-icon nc-simple-remove text-danger" v-else></i>
                </span>
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="form-group">
            <div class="col-sm-4">
                <p-button
                type="danger"
                :disabled="formData.mawbID === '' || isSubmitLoading === true"
                size="small"
                @click="showSwal('warning-message-and-confirmation')"
                >
                Submit
              </p-button>
            </div>
          </div>
        </fieldset>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from "vue"
import swal from 'sweetalert2'
import * as _apiCustomer from "@/api/customer"
import * as _apiMawb from "@/api/mawb"
import {mapGetters} from 'vuex'
import {
  DatePicker,
  Loading
} from "element-ui";

Vue.use(Loading)
Vue.use(DatePicker)

export default {
  components: {
  },
  data() {
    return {
    formData: {
      customerID: '',
      shipmentDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().slice(0, 10),
      mawbID: ''
    },
    pickerOptions1: {
      disabledDate: this.disabledDueDate,
    },
    arrivalsDate: [],
    options: [],
    loading: {},
    mawbList: [],
    isSubmitLoading: false
  }},
  computed: {
    ...mapGetters({
      currentUser: "$_user/currentUser",
      getSelected: "$_mawb/getSelected"
    }),
  },
  watch: {
    getSelected(v) {
      this.formData.shipmentDate = v.shipmentDate || (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().slice(0, 10)
      this.formData.mawbID = v.mawb || ''
    },
    'formData.shipmentDate': function(newVal, oldVal){
      if (newVal) {
        let _date = this.formatDate(newVal)
        this.getMAWBByDate(_date)
      }
    },
    'formData.customerID': function(newVal, oldVal){
        let _date = this.formatDate(this.formData.shipmentDate)
        this.getMAWBByDate(_date)
    }
  },
  created () {
    this.getAllCustomer()
    this.formData.shipmentDate = this.getSelected.shipmentDate
    this.formData.mawbID = this.getSelected.mawb
    // this.initialData(this.formData.shipmentDate, this.formData.mawbID)
    this.onChangeMawb(this.formData.mawbID)
    this.getArrivalsDate()
  },
  mounted () {
  },
  methods: {
    showSwal (str) {
      const _this = this
      swal({
        title: 'Are you sure submit?',
        text: `Please, checking info before confirm`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Confirm!',
        buttonsStyling: false
      }).then(function () {
        _this.submitInfoLink()
      })
    },
    initialData (date, mawbID) {
      let _date = this.formatDate(date)
      this.getMAWBByDate(_date)
    },
    getAllCustomer(){
      _apiCustomer.getAll()
      .then(response => {
        this.options = response.data
      })
      .catch(error => {
        this.$notify({
          message: error.response.data.message || 'Unsuccessfully',
          type: 'danger'
        })
      });
    },
    getMAWBByDate (date) {
      _apiMawb.getByDate(date)
      .then(res => {
        this.mawbList = res.data
      })
      .catch(error => {
        this.$notify({
            message: error.response.data.message || 'Unsuccessfully',
          type: 'danger'
        })
      })
    },
    submitInfoLink () {
      if (!this.formData.customerID) {
        alert('Please select customer')
        return
      }

      if (!this.formData.mawbID) {
        alert('Please select MAWB Number')
        return
      }

      this.openWrapperFullScreen()
      this.isSubmitLoading = true

      _apiMawb.infoLink(this.formData.customerID, this.formData.mawbID)
      .then(res => {
          this.$notify({
            message: 'Info Link Successfully',
            type: 'success'
          })
          this.getMAWBByDate(this.formatDate(this.formData.shipmentDate))
      })
      .catch(error => {
        this.$notify({
            message: error.response.data.message || 'Unsuccessfully',
          type: 'danger'
        })
      })
      .finally(() => {
        this.closeWrapperFullScreen()
        this.isSubmitLoading = false
      })
    },
    onChangeMawb (v) {
      if (!v) {
        return
      }
      this.$store.dispatch("$_mawb/ON_SELECTED_CHANGE", {
        shipmentDate: this.formData.shipmentDate,
        mawb: v
      })
    },
    onChangeShipmentDate (v) {
      this.formData.mawbID = ''
      if (v) {
        this.$store.dispatch("$_mawb/ON_SELECTED_CHANGE", {
          shipmentDate: v,
          mawb: this.selectedMAWB
        })
        this.initialData(v, '')
      }
    },
    disabledDueDate (time){
      return this.arrivalsDate.indexOf(time.getTime()) === -1
    },
    getArrivalsDate () {
      _apiMawb.getArrivalsDate()
      .then(res => {
        let data = res.data
        for(let i = 0; i < res.data.length; i++) {
          this.arrivalsDate.push(new Date(data[i].replace( /(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")).getTime())
        }
      })
      .catch(error => {
        this.$notify({
            message: 'Unsuccessfully Fetch Arrivals Date',
          type: 'danger'
        })
      })
    },
    openWrapperFullScreen() {
      this.loading = this.$loading({
        lock: true,
        text: 'Processing',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.9)'
      });
    },
    closeWrapperFullScreen() {
      this.loading.close()
    },
    formatDate(date) {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [day, month, year].join('-')
    },
  }
}
</script>
